
        // Initialize the nutrition modal
        import { NutritionModalFirebase } from './src/components/nutrition-modal-firebase.js';
        window.nutritionModal = new NutritionModalFirebase();

        // Initialize story loader
        import { StoryLoader } from './src/components/story-loader.js';
        window.storyLoader = new StoryLoader();

        // Initialize combo menu loader
        import { ComboMenu } from './src/components/combo-menu.js';
        window.comboMenu = new ComboMenu();
        window.comboMenu.init();

        // Initialize sauce menu loader
        import { SauceMenu } from './src/components/sauce-menu.js';
        window.sauceMenu = new SauceMenu();
        window.sauceMenu.init();

        // Initialize acquisition modal
        import { AcquisitionModal } from './src/components/acquisition-modal.js';
        window.acquisitionModal = new AcquisitionModal();
    